import { render, staticRenderFns } from "./DiermocratieSlide.vue?vue&type=template&id=a56043b4"
import script from "./DiermocratieSlide.vue?vue&type=script&lang=js"
export * from "./DiermocratieSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a56043b4')) {
      api.createRecord('a56043b4', component.options)
    } else {
      api.reload('a56043b4', component.options)
    }
    module.hot.accept("./DiermocratieSlide.vue?vue&type=template&id=a56043b4", function () {
      api.rerender('a56043b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/DiermocratieSlide.vue"
export default component.exports